<div style="position:sticky; top:-1px; z-index:100;">
  <app-dp-bottom-sheet-closer (closeClicked)="closesheet()" >
  </app-dp-bottom-sheet-closer>
</div>

<div class="master-search-component">
    <div class="d-flex justify-content-center align-items-center mb-4">
        <span class="master-search-text">Master Search</span>
      </div>

<div class="navBarMob">
    <ul class="navList">
      <li
        class="eachList"
        [ngClass]="{ linkTabactive: activeTab === 'globalSearch' }"
        (click)="activeTab = 'globalSearch'"
      >
        Global Search
      </li>
      <li
        class="eachList"
        [ngClass]="{ linkTabactive: activeTab === 'nameSearch' }"
        (click)="activeTab = 'nameSearch'"
      >
        Name Search
      </li>
      <li
        class="eachList"
        [ngClass]="{ linkTabactive: activeTab === 'keywordSearch' }"
        (click)="activeTab = 'keywordSearch'"
      >
        Keyword search
      </li>
    </ul>
  </div>
  <div>
    <span class="mobile-view-devider"></span>

    <div >
        @if(activeTab === 'globalSearch'){

            <app-global-search-tab-responsive [data]="data" (serialNo)="onClickSerialNo($event)"></app-global-search-tab-responsive>
        }@else if(activeTab === 'nameSearch'){

            <app-name-search-tab-responsive [data]="data" (serialNo)="onClickSerialNo($event)"></app-name-search-tab-responsive>
        }@else if(activeTab === 'keywordSearch'){
            <app-keyword-search-tab-responsive (serialNo)="onClickSerialNo($event)"></app-keyword-search-tab-responsive>

        }
        

    </div>

</div>